import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { DashboardLayout } from '@/components/Dashboard/DashboardLayout';
import { PlybookList, PlybookDetail } from '@/components/Plybook';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Info } from 'lucide-react';
import type { Plybook } from '@/types/plybook';

export default function Plybooks() {
  const [selectedPlybook, setSelectedPlybook] = useState<Plybook | null>(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const fromProduct = searchParams.get('from') === 'product';
  const customerId = searchParams.get('customer_id');
  const projectId = searchParams.get('project_id');

  const handlePlybookCreated = (plybookId: string) => {
    if (fromProduct) {
      localStorage.setItem('new_plybook_for_product', plybookId);
    }
  };

  const handleBackToProduct = () => {
    navigate('/products');
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {fromProduct && (
          <Alert className="bg-blue-50 border-blue-200 dark:bg-blue-950 dark:border-blue-800">
            <Info className="w-4 h-4 text-blue-600" />
            <AlertDescription className="flex items-center justify-between">
              <span>Creando plybook para nuevo producto. Al finalizar, vuelve a continuar con el producto.</span>
              <Button variant="outline" size="sm" onClick={handleBackToProduct}>
                <ArrowLeft className="w-4 h-4 mr-1" />
                Volver a Productos
              </Button>
            </AlertDescription>
          </Alert>
        )}

        {!selectedPlybook ? (
          <>
            <div>
              <h1 className="text-2xl font-bold">Plybooks</h1>
              <p className="text-muted-foreground">
                Hojas de laminado - Define la secuencia de capas para tus productos de composites
              </p>
            </div>

            <PlybookList 
              onSelect={setSelectedPlybook}
              onPlybookCreated={fromProduct ? handlePlybookCreated : undefined}
              defaultCustomerId={customerId || undefined}
              defaultProjectId={projectId || undefined}
            />
          </>
        ) : (
          <PlybookDetail
            plybookId={selectedPlybook.id}
            onBack={() => setSelectedPlybook(null)}
          />
        )}
      </div>
    </DashboardLayout>
  );
}
